import { IEndpoints } from "./interface";

export const bondPrices: IEndpoints = {
  createBondPrices: {
    api: "/Admin/Bonds/BondPricesData",
    method: "post",
    baseURL: "auth",
  },
};

export const bonds: IEndpoints = {
  get: {
    api: "/Bonds",
    method: "get",
    baseURL: "auth",
  },
  getAllBonds: {
    api: "/Bonds/GetAllBonds",
    method: "get",
    baseURL: "auth",
  },
  getFullText: {
    api: "/Bonds",
    method: "get",
    baseURL: "auth",
  },
  createSearchFilter: {
    api: "/SearchFilters/CreateSearchFilter",
    method: "post",
    baseURL: "auth",
  },
  renameFilter: {
    api: "/SearchFilters/RenameSearchFilter",
    method: "put",
    baseURL: "auth",
  },
  createBondPosition: {
    api: "/PortfoliosDetails/CreatePortfolioDetails",
    method: "post",
    baseURL: "auth",
  },
  PositionPortfolioDetails: {
    api: "/Portfolios/GetPortfolioList",
    method: "get",
    baseURL: "auth",
  },
  PositionPortfolioPriceByDate: {
    api: "/Bonds/GetBondPriceByDate",
    method: "get",
    baseURL: "auth",
  },
  searchFilterDetails: {
    api: "/SearchFilters/SearchFilterDetails",
    method: "get",
    baseURL: "auth",
  },
  bondSearchFilterList: {
    api: "/SearchFilters",
    method: "get",
    baseURL: "auth",
  },
  bondOfInterest: {
    api: "/Bonds/BondOfInterest",
    method: "get",
    baseURL: "auth",
  },
  trendingFlag: {
    api: "/Bonds/TrendingFlag",
    method: "get",
    baseURL: "auth",
  },
  followBond: {
    api: "/Bonds/FollowBond",
    method: "post",
    baseURL: "auth",
  },
  bondPosition: {
    api: "/Bonds/GetBriefBondDetail",
    method: "get",
    baseURL: "auth",
  },
  bondPriceCharts: {
    api: "/Bonds/GetBondPriceGraph",
    method: "get",
    baseURL: "auth",
  },
  bondDetailToken: {
    api: "/Bonds/GetBondDetailToken",
    method: "get",
    baseURL: "auth",
  },
  sameIssuerBonds: {
    api: "/Bonds/GetIssuerBondInfo",
    method: "get",
    baseURL: "auth",
  },

  getBondHeader: {
    api: "/Bonds/GetBondHeader",
    method: "get",
    baseURL: "auth",
  },
  getBondAnalytics: {
    api: "/Bonds/GetBondAnalytics",
    method: "get",
    baseURL: "auth",
  },
  getbondsDetailData: {
    api: "/Bonds/GetBondInfo",
    method: "get",
    baseURL: "auth",
  },
  getIssuerList: {
    api: "/Bonds/GetIssuerByFirstLetter",
    method: "get",
    baseURL: "auth",
  },
  getIssuerFirstLetterList: {
    api: "/Bonds/GetIssuerFirstLetter",
    method: "get",
    baseURL: "auth",
  },
  getIssuerHistory: {
    api: "/Bonds/GetIssuerHistory",
    method: "post",
    baseURL: "auth",
  },
  getIssuerListByChar: {
    api: "/Bonds/GetIssuerByFirstLetter",
    method: "get",
    baseURL: "auth",
  },
};

export const dashboard: IEndpoints = {
  bondPriceCharts: {
    api: "/Dashboard/BondPriceCharts",
    method: "get",
    baseURL: "auth",
  },
  bondPriceChartsByIsin: {
    api: "/Bonds/GetBondPriceGraphByIsin",
    method: "get",
    baseURL: "auth",
  },
  bondOfInterest: {
    api: "/Dashboard/WinnersAndLosers",
    method: "get",
    baseURL: "auth",
  },
  trendingFlag: {
    api: "/Dashboard/TrendingBonds",
    method: "get",
    baseURL: "auth",
  },
  recentPrice: {
    api: "/Dashboard/RecentPrices",
    method: "get",
    baseURL: "auth",
  },
  recentIssues: {
    api: "/Dashboard/DashBoardRecentIssues",
    method: "get",
    baseURL: "auth",
  },
  bondFollowedbyUser: {
    api: "/Dashboard/GetFollowedBondDetailsList",
    method: "get",
    baseURL: "auth",
  },
  bondsInPositionAndFollowedbyUser: {
    api: "/Dashboard/GetFollowAndPortfolioBonds",
    method: "get",
    baseURL: "auth",
  },
  positionBondsbyUser: {
    api: "/Dashboard/MyPortfolioBonds",
    method: "get",
    baseURL: "auth",
  },
  featuredSearch: {
    api: "/Dashboard/FeaturedSearch",
    method: "get",
    baseURL: "auth",
  },
  markAsDefaultGraph: {
    api: "/Dashboard/MarkAsDefaultGraph",
    method: "put",
    baseURL: "auth",
  },
  deleteFilter: {
    api: "/SearchFilters/DeleteBySearchFilterId",
    method: "delete",
    baseURL: "auth",
  },
};

export const portfolios: IEndpoints = {
  get: {
    api: "/Portfolios/GetPortfoliosNew",
    method: "get",
    baseURL: "auth",
  },
  getExcel: {
    api: "/Portfolios/ExportPortfoliosData",
    method: "get",
    baseURL: "auth",
  },
  getPosition: {
    api: "/Portfolios/GetPositionsNew",
    method: "get",
    baseURL: "auth",
  },
  getView: {
    api: "/Portfolios/GetPositionDetailNew",
    method: "get",
    baseURL: "auth",
  },
  getPositionDetail: {
    api: "/PortfoliosDetails/GetByPortfolioDetailId",
    method: "get",
    baseURL: "auth",
  },
  getPotfolioList: {
    api: "/Portfolios/GetPortfolioList",
    method: "get",
    baseURL: "auth",
  },
  getPotfolioUpdate: {
    api: "/PortfoliosDetails/UpdateByPortfolioDetailId",
    method: "put",
    baseURL: "auth",
  },

  post: {
    api: "/Portfolios/CreatePortfolio",
    method: "post",
    baseURL: "auth",
  },
  put: {
    api: "/Portfolios/UpdateByPortfolioId",
    method: "put",
    baseURL: "auth",
  },
  delete: {
    api: "/Portfolios/DeleteByPortfolioId",
    method: "delete",
    baseURL: "auth",
  },
  deletePosition: {
    api: "/PortfoliosDetails/DeleteByPortfolioDetailId",
    method: "delete",
    baseURL: "auth",
  },
};

export const authenticate: IEndpoints = {
  login: {
    api: "/Authentication/Login",
    baseURL: "auth",
    // api: "/nextapi/login",
    // baseURL: "next",
    method: "post",
  },
  oAuthLogin: {
    api: "/Authentication/OauthRegister",
    method: "post",
    baseURL: "auth",
  },
  isUserExists: {
    api: "/Authentication/IsUserExists",
    method: "post",
    baseURL: "auth",
  },
  refreshToken: {
    api: "/Authentication/RefreshToken",
    method: "post",
    baseURL: "auth",
  },
  registerUser: {
    api: "/Authentication/RegisterUser",
    method: "post",
    baseURL: "auth",
  },
  deviceLogout: {
    api: "/Authentication/DeviceLogout",
    method: "post",
    baseURL: "auth",
  },
  logout: {
    api: "/Authentication/Logout",
    method: "post",
    baseURL: "auth",
  },
  put: {
    api: "/Portfolios/UpdateByPortfolioId",
    method: "put",
    baseURL: "auth",
  },
  delete: {
    api: "/Portfolios/DeleteByPortfolioId",
    method: "delete",
    baseURL: "auth",
  },
  forgot: {
    api: "/Authentication/ForgotPassword",
    method: "post",
    baseURL: "auth",
  },
  reset: {
    api: "/Authentication/ResetPassword",
    method: "post",
    baseURL: "auth",
  },
  updateEmail: {
    api: "/Users/UpdateEmail",
    method: "put",
    baseURL: "auth",
  },
  OTP: {
    api: "/Users/GetEmailOtp",
    method: "put",
    baseURL: "auth",
  },
  activation: {
    api: "/Authentication/ActivateUserAccount",
    method: "post",
    baseURL: "auth",
  },
  resendActivation: {
    api: "/Authentication/ResendVerificationMail",
    method: "post",
    baseURL: "auth",
  },
  notification: {
    api: "/Notifications",
    method: "get",
    baseURL: "auth",
  },
  removeNoti: {
    api: "/Notifications/MarkAsRead",
    method: "put",
    baseURL: "auth",
  },
  changeAccountPassword: {
    api: "/Authentication/ChangePassword",
    method: "post",
    baseURL: "auth",
  },
  requestEmailChange: {
    api: "/Users/RequestUpdateEmail",
    method: "put",
    baseURL: "auth",
  },
  isUserNameAndEmailExists: {
    api: "/Authentication/IsUserNameAndEmailExists",
    method: "get",
    baseURL: "auth",
  },
};
export const discussion: IEndpoints = {
  get: {
    api: "/Posts/GetAllPosts",
    method: "get",
    baseURL: "auth",
  },
  put: {
    api: "/Posts/UpdatePost",
    method: "put",
    baseURL: "auth",
  },
  getTrendingPosts: {
    api: "/Posts/TrendingPosts",
    method: "get",
    baseURL: "auth",
  },
  getPostById: {
    api: "/Posts/GetPostDetails",
    method: "get",
    baseURL: "auth",
  },
  getRecentPostByUserId: {
    api: "/Posts/GetPostsByUserId",
    method: "get",
    baseURL: "auth",
  },
  getJoinedPostByUserId: {
    api: "/Posts/GetJoinedPosts",
    method: "get",
    baseURL: "auth",
  },
  createPost: {
    api: "/Posts/CreatePost",
    method: "post",
    baseURL: "auth",
  },
  LikeUnlikePost: {
    api: "/Posts/LikeUnlikePost",
    method: "put",
    baseURL: "auth",
  },
  LikeUnlikeComment: {
    api: "/PostComments/LikeUnlikeComment",
    method: "put",
    baseURL: "auth",
  },
  LikeUnlikeReply: {
    api: "/PostCommentsReply/LikeUnlikeReply",
    method: "put",
    baseURL: "auth",
  },
  delete: {
    api: "/Posts/DeletePost",
    method: "delete",
    baseURL: "auth",
  },
  putJoinPost: {
    api: "/Posts/JoinPost",
    method: "put",
    baseURL: "auth",
  },
  CreateByComment: {
    api: "/PostComments/CreateByComment",
    method: "post",
    baseURL: "normal",
  },
  CreateReply: {
    api: "/PostCommentsReply/CreateReply",
    method: "post",
    baseURL: "normal",
  },
  UpdateByCommentId: {
    api: "/PostComments/UpdateByCommentId",
    method: "put",
    baseURL: "normal",
  },
  UpdateCommentReply: {
    api: "/PostCommentsReply/UpdatetReply",
    method: "put",
    baseURL: "normal",
  },
  postReport: {
    api: "/Posts/RequestModeration",
    method: "put",
    baseURL: "auth",
  },
  DeleteByCommentId: {
    api: "/PostComments/DeleteByCommentId",
    method: "delete",
    baseURL: "normal",
  },
  DeleteCommentsReplyById: {
    api: "/PostCommentsReply/DeleteReply",
    method: "delete",
    baseURL: "normal",
  },
};
export const adminAnalaytics: IEndpoints = {
  get: {
    api: "/Admin/ReteriveAnalytics",
    method: "get",
    baseURL: "auth",
  },
}
export const adminAnalayticsGraph: IEndpoints = {
  pageView: {
    get: {
      api: "/Admin/PageViewsGraph",
      method: "get",
      baseURL: "auth",
    }
  },
  CTA: {
    get: {
      api: "/Admin/CallToActionGraph",
      method: "get",
      baseURL: "auth",
    }
  },
  uniqueView: {
    get: {
      api: "/Admin/UniqueViewsGraph",
      method: "get",
      baseURL: "auth",
    }
  },
  navigationPath: {
    get: {
      api: "/Admin/PageNavigationGraph",
      method: "get",
      baseURL: "auth",
    }
  },
  analyticsCTAGraph: {
    get: {
      api: "/Admin/AnalyticsCtaGraph",
      method: "get",
      baseURL: "auth",
    }
  },
  analyticsDeviceBrowserChart: {
    get: {
      api: "/Admin/DeviceBrowserAnalytics",
      method: "get",
      baseURL: "auth",
    }
  },
  analyticsCountryUsersChart: {
    get: {
      api: "/Admin/CountryAnalytics",
      method: "get",
      baseURL: "auth",
    }
  },
  averageSessionGraph: {
    get: {
      api: "/Admin/AverageDurationGraph",
      method: "get",
      baseURL: "auth",
    }
  },
  bounceRateGraph: {
    get: {
      api: "/Admin/BounceRateGraph",
      method: "get",
      baseURL: "auth",
    }
  },
  TableAnalyticsData: {
    getAnalytics: {
      api: "/Admin/AverageSessionDuration",
      method: "get",
      baseURL: "auth",
    },
    getAverageSessionDurationTable: {
      api: "/Admin/AverageSessionDuration",
      method: "get",
      baseURL: "auth",
    },
    getExit: {
      api: "/Admin/AnalyticsExitPage",
      method: "get",
      baseURL: "auth",
    },
  },
  DataTable: {
    getDataTable: {
      api: "/Admin/CountryDetailsAnalytics",
      method: "get",
      baseURL: "auth",
    },
    getAdsLogTable: {
      api: "/Admin/AdsLogs",
      method: "get",
      baseURL: "auth",
    }
  }
}
export const adminBlog: IEndpoints = {
  create: {
    api: "/Admin/CreateBlog",
    method: "post",
    baseURL: "auth",
  },
  update: {
    api: "/Admin/UpdateBlogById",
    method: "put",
    baseURL: "auth",
  },
  getAllBlog: {
    api: "/Common/AllBlogs",
    method: "get",
    baseURL: "auth",
  },
  delete: {
    api: "/Admin/DeleteBlogById",
    method: "delete",
    baseURL: "auth",
  },
}
export const adminPost: IEndpoints = {
  get: {
    api: "/Admin/Posts",
    method: "get",
    baseURL: "auth",
  },
  getById: {
    api: "/Admin/Posts/GetPost",
    method: "get",
    baseURL: "auth",
  },
  post: {
    api: "/Admin/Posts/CreatePost",
    method: "post",
    baseURL: "auth",
  },
  put: {
    api: "/Admin/Posts/UpdatePost",
    method: "put",
    baseURL: "auth",
  },
  delete: {
    api: "/Admin/Posts/DeletePost",
    method: "delete",
    baseURL: "auth",
  },
  inactive: {
    api: "/Admin/Posts/InActivatePost",
    method: "put",
    baseURL: "auth",
  },
  reqForModeration: {
    api: "/Admin/Posts/RequestModeration",
    method: "put",
    baseURL: "auth",
  },
};
export const adsLink: IEndpoints = {
  get: {
    api: "/Admin/AllAds",
    method: "get",
    baseURL: "auth",
  },
  getById: {
    api: "/Admin/Posts/GetPost",
    method: "get",
    baseURL: "auth",
  },
  post: {
    api: "/Admin/CreateAds",
    method: "post",
    baseURL: "auth",
  },
  put: {
    api: "/Admin/UpdateAds",
    method: "put",
    baseURL: "auth",
  },
  delete: {
    api: "/Admin/DeleteAds",
    method: "delete",
    baseURL: "auth",
  },
  inactive: {
    api: "/Admin/InActivateAds",
    method: "put",
    baseURL: "auth",
  },
  reqForModeration: {
    api: "/Admin/Posts/RequestModeration",
    method: "put",
    baseURL: "auth",
  },
};
export const moderations: IEndpoints = {
  get: {
    api: "/Admin/Moderations",
    method: "get",
    baseURL: "auth",
  },
  inactivateContent: {
    api: "/Admin/Moderations/InActivateContent",
    method: "put",
    baseURL: "auth",
  },
  getById: {
    api: "/Admin/Moderations/GetModeration",
    method: "get",
    baseURL: "auth",
  },
  getViewReportsById: {
    api: "/Admin/Moderations/ViewReasons",
    method: "get",
    baseURL: "auth",
  },
  post: {
    api: "/Admin/Moderations/CreatePostModeration",
    method: "post",
    baseURL: "auth",
  },
  put: {
    api: "/Admin/Moderations/UpdateModeration",
    method: "put",
    baseURL: "auth",
  },
  delete: {
    api: "/Admin/Moderations/DeleteModeration",
    method: "delete",
    baseURL: "auth",
  },
};

export const AdminUsers: IEndpoints = {
  get: {
    api: "/Admin/Users",
    method: "get",
    baseURL: "auth",
  },
  getById: {
    api: "/Admin/Users/EditUser",
    method: "get",
    baseURL: "auth",
  },
  post: {
    api: "/Admin/Users/RegisterUserByAdmin",
    method: "post",
    baseURL: "auth",
  },
  put: {
    api: "/Admin/Users/UpdateUser",
    method: "put",
    baseURL: "auth",
  },
  delete: {
    api: "/Admin/Users/DeleteByUserId",
    method: "delete",
    baseURL: "auth",
  },
  inActive: {
    api: "/Admin/Users/InActivateUser",
    method: "put",
    baseURL: "auth",
  },
};
export const Users: IEndpoints = {
  get: {
    api: "/Users/ViewMyProfile",
    method: "get",
    baseURL: "auth",
  },
  getUserFollowing: {
    api: "/Users/FollowingUser",
    method: "get",
    baseURL: "auth",
  },
  getUserFollowed: {
    api: "/Users/FollowedUser",
    method: "get",
    baseURL: "auth",
  },
  unFollow: {
    api: "/Users/FollowUser",
    method: "post",
    baseURL: "auth",
  },
  put: {
    api: "/Users/UpdateUser",
    method: "put",
    baseURL: "auth",
  },
  delete: {
    api: "/Users/DeleteUserAccount",
    method: "delete",
    baseURL: "auth",
  },
  deleteImage: {
    api: "/Users/DeleteUserProfilePicture",
    method: "delete",
    baseURL: "auth",
  },
};

export const AdminRoles: IEndpoints = {
  get: {
    api: "/Admin/UserRoles",
    method: "get",
    baseURL: "auth",
  },
};
export const common: IEndpoints = {
  countries: {
    api: "/Common/GetCountriesFromBonds",
    method: "get",
    baseURL: "auth",
  },
  trendingBonds: {
    api: "/Common/TrendingBonds",
    method: "get",
    baseURL: "auth",
  },
  issueType: {
    api: "/Common/GetIssueTypes",
    method: "get",
    baseURL: "auth",
  },
  currency: {
    api: "/Common/GetCurrenciesFromBonds",
    method: "get",
    baseURL: "auth",
  },
  regions: {
    api: "/Common/GetRegions",
    method: "get",
    baseURL: "auth",
  },
  sectors: {
    api: "/Common/GetSectors",
    method: "get",
    baseURL: "auth",
  },
  industry: {
    api: "/Common/GetIndustriesFromBonds",
    method: "get",
    baseURL: "auth",
  },
  MaturityYears: {
    api: "/Common/GetMaturityYears",
    method: "get",
    baseURL: "auth",
  },
  sendFeedBack: {
    api: "/Common/SendFeedbackMessage",
    method: "post",
    baseURL: "auth",
  },
  support: {
    api: "/Common/CreateIssueTicket",
    method: "post",
    baseURL: "auth",
  },
  getUploadStatus: {
    api: "/Common/DataUploadStatus",
    method: "get",
    baseURL: "auth",
  },
  getAdsKeyExists: {
    api: "/Common/KeyExists",
    method: "get",
    baseURL: "auth",
  },
  createAdsKeyExists: {
    api: "/Common/CreateAdsLog",
    method: "post",
    baseURL: "auth",
  },
};
export const access: IEndpoints = {
  access: {
    api: "/Common/AccessFeaturesGetMenuList",
    method: "get",
    baseURL: "auth",
  },
  accessPut: {
    api: "/Admin/EnableDisableFeatures",
    method: "put",
    baseURL: "auth",
  },
  toggleDataUploadStatus: {
    api: "/Admin/DataUploadStatus",
    method: "put",
    baseURL: "auth",
  },
};
export const adminPortfolios: IEndpoints = {
  get: {
    api: "/Admin/Portfolios/UsersBasedPortfolios",
    method: "get",
    baseURL: "auth",
  },
  getPortfolios:{
    api: "/Admin/GetPortfoliosNew",
    method: "get",
    baseURL: "auth",
  },
  getPositionsOfPortfolio:{
    api: "/Admin/GetPositionsNew",
    method: "get",
    baseURL: "auth",
  },
  getById: {
    api: "/Admin/Portfolios/GetPortfolio",
    method: "get",
    baseURL: "auth",
  },
  post: {
    api: "/Admin/Portfolios/CreatePortfolio",
    method: "post",
    baseURL: "auth",
  },
  put: {
    api: "/Admin/Portfolios/UpdatePortfolio",
    method: "put",
    baseURL: "auth",
  },
  delete: {
    api: "/Admin/Portfolios/DeletePortfolio",
    method: "delete",
    baseURL: "auth",
  },
};

export const adminUserRoles: IEndpoints = {
  get: {
    api: "/Admin/UserRoles",
    method: "get",
    baseURL: "auth",
  },
  getById: {
    api: "/Admin/UserRoles/EditUserRole",
    method: "get",
    baseURL: "auth",
  },
  post: {
    api: "/Admin/UserRoles/CreateRole",
    method: "post",
    baseURL: "auth",
  },
  put: {
    api: "/Admin/UserRoles/UpdateByUserRoleId",
    method: "put",
    baseURL: "auth",
  },
  delete: {
    api: "/Admin/UserRoles/DeleteUserRole",
    method: "delete",
    baseURL: "auth",
  },
};

export const adminPostModerate: IEndpoints = {
  get: {
    api: "/Moderations",
    method: "get",
    baseURL: "auth",
  },
  post: {
    api: "/Moderations",
    method: "post",
    baseURL: "auth",
  },
  put: {
    api: "/Moderations/UpdateByPostId",
    method: "put",
    baseURL: "auth",
  },
  delete: {
    api: "/Moderations/DeleteByPostId",
    method: "delete",
    baseURL: "auth",
  },
};

export const adminPosts: IEndpoints = {
  get: {
    api: "/Admin/Posts",
    method: "get",
    baseURL: "auth",
  },
  post: {
    api: "/Admin/Posts/CreatePost",
    method: "post",
    baseURL: "auth",
  },
  put: {
    api: "/Admin/Posts/UpdatePost",
    method: "put",
    baseURL: "auth",
  },
  delete: {
    api: "/Admin/Posts/DeletePost",
    method: "delete",
    baseURL: "auth",
  },
};

export const adminBonds: IEndpoints = {
  get: {
    api: "/Admin/Bonds/SearchBondsByAdmin",
    method: "get",
    baseURL: "auth",
  },
  getById: {
    api: "/Admin/Bonds/EditBond",
    method: "get",
    baseURL: "auth",
  },
  post: {
    api: "/Admin/Bonds/BondsData",
    method: "post",
    baseURL: "auth",
  },
  // put: {
  //   api: "/Admin/Bonds/UpdateBond",
  //   method: "put",
  //   baseURL: "auth",
  // },
  delete: {
    api: "/Bonds/DeleteBondById",
    method: "delete",
    baseURL: "auth",
  },
};

export const adminSubscription: IEndpoints = {
  get: {
    api: "/Admin/Subscriptions",
    method: "get",
    baseURL: "auth",
  },
  getById: {
    api: "/Admin/Subscriptions/GetSubscription",
    method: "get",
    baseURL: "auth",
  },
  post: {
    api: "/Admin/Subscriptions/CreateSubscription",
    method: "post",
    baseURL: "auth",
  },
  put: {
    api: "/Admin/Subscriptions/UpdateSubscription",
    method: "put",
    baseURL: "auth",
  },
  delete: {
    api: "/Admin/Subscriptions/DeleteSubscription",
    method: "delete",
    baseURL: "auth",
  },
};

export const adminSubscriptionPlan: IEndpoints = {
  get: {
    api: "/SubscriptionPlans",
    method: "get",
    baseURL: "auth",
  },
  getById: {
    api: "/Admin/SubscriptionPlans/GetSubscriptionPlan",
    method: "get",
    baseURL: "auth",
  },
  post: {
    api: "/Admin/SubscriptionPlans/CreateSubscriptionPlan",
    method: "post",
    baseURL: "auth",
  },
  put: {
    api: "/Admin/SubscriptionPlans/UpdateSubscriptionPlan",
    method: "put",
    baseURL: "auth",
  },
  delete: {
    api: "/Admin/SubscriptionPlans/DeleteSubscriptionPlan",
    method: "delete",
    baseURL: "auth",
  },
};

export const adminPosition: IEndpoints = {
  get: {
    api: "/Admin/Positions",
    method: "get",
    baseURL: "auth",
  },
  getById: {
    api: "/Admin/Positions/GetPosition",
    method: "get",
    baseURL: "auth",
  },
  post: {
    api: "/Admin/Positions/CreatePosition",
    method: "post",
    baseURL: "auth",
  },
  put: {
    api: "/Admin/Positions/UpdatePosition",
    method: "put",
    baseURL: "auth",
  },
  delete: {
    api: "/Admin/Positions/DeletePosition",
    method: "delete",
    baseURL: "auth",
  },
};

export const adminSearchFilter: IEndpoints = {
  get: {
    api: "/Admin/SearchFilters",
    method: "get",
    baseURL: "auth",
  },
  getById: {
    api: "/Admin/SearchFilters/SearchFilterDetails",
    method: "get",
    baseURL: "auth",
  },
  post: {
    api: "/Admin/SearchFilters/CreateSearchFilter",
    method: "post",
    baseURL: "auth",
  },
  put: {
    api: "/Admin/SearchFilters/UpdateSearchFilter",
    method: "put",
    baseURL: "auth",
  },
  mark: {
    api: "/Admin/SearchFilters/MarkAsFeaturedSearch",
    method: "put",
    baseURL: "auth",
  },
  delete: {
    api: "/Admin/SearchFilters/DeleteSearchFilter",
    method: "delete",
    baseURL: "auth",
  },
};

export const postComments: IEndpoints = {
  get: {
    api: "/Posts",
    method: "get",
    baseURL: "normal",
  },
  post: {
    api: "/Posts/CreatePost",
    method: "post",
    baseURL: "normal",
  },
  put: {
    api: "/Posts/UpdatePost",
    method: "put",
    baseURL: "normal",
  },
  CreateByComment: {
    api: "/PostComments/CreateByComment",
    method: "post",
    baseURL: "normal",
  },
  UpdateByCommentId: {
    api: "/PostComments/UpdateByCommentId",
    method: "put",
    baseURL: "normal",
  },
  LikeUnlikePost: {
    api: "/Posts/LikeUnlikePost",
    method: "put",
    baseURL: "normal",
  },
  LikeUnlikeComment: {
    api: "/PostComments/LikeUnlikeComment",
    method: "put",
    baseURL: "normal",
  },
  DeletePost: {
    api: "/Posts/DeletePost",
    method: "delete",
    baseURL: "normal",
  },
  DeleteByCommentId: {
    api: "/PostComments/DeleteByCommentId",
    method: "delete",
    baseURL: "normal",
  },
  RequestModeration: {
    api: "/Posts/RequestModeration",
    method: "put",
    baseURL: "normal",
  },
};
export const sendEmail: IEndpoints = {
  post: {
    api: "/Admin/CreateMailNotifications",
    method: "post",
    baseURL: "auth",
  },
};
export const tradeBoardCast: IEndpoints = {
  get: {
    api: "/TradeBroadcast",
    method: "get",
    baseURL: "auth",
  },
};

export const searchFilters: IEndpoints = {
  get: {
    api: "/SearchFilters/GetSearchFilterByUserId",
    method: "get",
    baseURL: "auth",
  },
};
